export const LOGGED_OUT_HEADER_TYPE = 'logged_out';
export const LOGGED_OUT_SIDEBAR_TYPE = 'guest';

export const LOGO_MAKER_LINK_KEY = 'logo_maker';
